import { atom } from 'jotai';

export const isWebsocketErrorAtom = atom(false);
